// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1___06beead34caf7d8b62f","cls2":"Cta-cls2___73eeb92a2a4b1f98f7b Cta-cls1___06beead34caf7d8b62f"};